import React, { useState, useEffect } from 'react'
import Button from '@mui/material/Button'
// import TextField from '@mui/material/TextField'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
// import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
// import CustomButton from '../../../Components/CustomButton/CustomButton'
import ComboBox from '../../../../Components/ComboBox'
import { Input } from '../../../../Components/Input'
import { useForm } from 'react-hook-form'
import { makeGetRequest, makePostRequest, makePutRequest } from '../../../../utils/api'
import urls from '../../../../utils/urls'
import { Box } from '@mui/material'
import { currentDate, convertToMuiDate } from '../../../../utils/helpers'
// import EditIcon from '@mui/icons-material/Edit'
// import ButtonGroup from '@mui/material/ButtonGroup'
// import Tooltip from '@mui/material/Tooltip'
// import { styled } from '@mui/material/styles'
// import UploadFileIcon from '@mui/icons-material/UploadFile'
// import Link from '@mui/material/Link'

// import Stack from '@mui/material/Stack'

export default function EditOperationForm({
  setOperations,
  params,
  operations,
  vehiculesTypes,
  setSelected,
  carLogoType,
}) {
  const [open, setOpen] = useState(true)
  const [moterType, setMotortype] = useState([])
  const [boatType, setBoatType] = useState([])
  // const [selectedRow, setSelectedRow] = useState({})
  const [vehicleType, setVehicleType] = useState({})
  const [marqueType, setMarqueType] = useState({})
  const [Motortypes, setMotortypes] = useState({})
  const [boatTypes, setBoatTypes] = useState({})

  const [carTypes, setCarTypes] = useState([])
  // const [carLogoTypes, setCarLogoTypes] = useState([])

  const [carType, setCarType] = useState({})
  // const [carLogoType, setCarLogoType] = useState({})
  // const [carLogoType, setCarLogoType] = useState([])
  // const [carLogoTypedata, setCarLogoTypedata] = useState([])

  const [carMarque, setCarMarque] = useState([])

  const [selectedVehicle, setSelectedVehicle] = useState('')

  const log = () => {
    setValue('vehicleType', {
      label: `${params[0].vehicletypes.vehicletype}`,
      id: params[0].vehicletypes.id,
    })
    setValue('Motortype', {
      label: `${params[0].Motortypes.motor_type}`,
      id: params[0].Motortypes.id,
    })
    setValue('Model', { label: `${params[0].Models.Name}`, id: params[0].Models.id })
    setValue('Marque', { label: `${params[0].Marques.Name}`, id: params[0].Marques.id })
    setVehicleType({
      label: `${params[0].vehicletypes.vehicletype}`,
      id: params[0].vehicletypes.id,
    })
    setMarqueType({ label: `${params[0].Models.Marques.Marque}`, id: params[0].Models.Marques.id })

    setMotortypes({ label: `${params[0].Motortypes.motor_type}`, id: params[0].Motortypes.id })
    setCarType({ label: `${params[0].Models.Name}`, id: params[0].Models.id })
    // setCarLogoType({ label: `${params[0].Marques.Marque}`, id: params[0].Marques.id })
    if (params[0].boatTypes.boat_type !== null) {
      setSelectedVehicle(params[0].vehicletypes.vehicletype)
      setValue('boatType', {
        label: `${params[0].boatTypes.boat_type}`,
        id: params[0].boatTypes.id,
      })
      setBoatTypes({ label: `${params[0].boatTypes.boat_type}`, id: params[0].boatTypes.id })
    }
    // setVehicleMarque(j.id)
  }

  useEffect(() => {
    // fetchCarPicModel()
    // fetchOperations()
    fetchCarLogoModel()
    fetchMotorTypes()
    fetchBoatTypes()
    log()
    const filterTypes = []
    carLogoType.forEach((v) => {
      filterTypes.push({ label: `${v.Name}`, id: v.id })
    })
    setCarTypes([...filterTypes])
  }, [])

  const { handleSubmit, control, setValue, reset } = useForm({
    defaultValues: {
      id: params[0].id,
      vehicleType: '',
      // Marque : params[0].Marque,
      Marque: '',
      Model: params[0].Model,
      Motortype: '',
      Conso: params[0].Conso,
      Contact: params[0].Contact,
      DatePurch: params[0].DatePurch ? convertToMuiDate(params[0].DatePurch) : '',
      Identification: params[0].Identification,
      boatType: '',
      Vhpower: params[0].Vhpower,
      emission: params[0].emission,
    },
  })

  const setVehicleMarque = (id) => {
    const carLogoTypes = []
    carLogoType.forEach((v) => {
      if (v.vehicletype === id) {
        carLogoTypes.push({ label: `${v.Marques.Marque}`, id: v.Marques.id })
      }
    })
    setCarMarque(carLogoTypes)
  }

  const handleClose = () => {
    setOpen(false)
    reset()
    setSelected(false)
  }

  const onSubmit = async (data) => {
    if (data.vehicleType === null) {
      alert('Please Select Type de véhicule.')
    } else {
      const payload = {
        ...data,
        vehicleType: data.vehicleType.id,
        Motortype: data.Motortype.id,
        Model: data.Model.id,
        Marque: data.Marque.id,
      }
      if (data.boatType !== '' && payload.boatType !== null) {
        if (selectedVehicle === 'Nautisme') {
          payload.boatType = data.boatType.id
        } else {
          payload.boatType = ''
        }
      }
      if (data.Conso === '') {
        payload.Conso = 0
      }
      if (data.Vhpower === '') {
        payload.Vhpower = 0
      }
      if (data.emission === '') {
        payload.emission = 0
      }
      const response = await makePutRequest(
        urls.crudVehiclesOperations + `${data.id}/`,
        payload,
        {},
        true,
      )

      if (response.status === 200) {
        let id = response.data.id
        const filteredOperations = operations.results.filter((v) => v.id !== id)
        const updatedOperations = [...filteredOperations, { ...response.data }].sort((a, b) =>
          a.id > b.id ? 1 : -1,
        )

        setOperations((operations) => ({
          ...operations,
          results: updatedOperations,
        }))
        // setOperations( operations => ( {
        //   ...operations,
        //   results: [ ...operations.results, response.data ],
        //   count: operations.count + 1,
        // } ) )
        handleClose()
      }
    }
  }

  const fetchMotorTypes = async () => {
    const url = urls.fetchMotorTypes + '?limit=100000'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterTypes = []
      data.forEach((v) => {
        filterTypes.push({ label: `${v.motor_type}`, id: v.id })
      })
      setMotortype([...filterTypes])
    }
  }
  const fetchBoatTypes = async () => {
    const url = urls.fetchBoatTypes + '?limit=100000'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterTypes = []
      data.forEach((v) => {
        filterTypes.push({ label: `${v.boat_type}`, id: v.id })
      })
      setBoatType([...filterTypes])
    }
  }
  // const fetchCarPicModel = async () => {
  //   const url = urls.fetchCarPicModel
  //   const { data, status } = await makeGetRequest(url, {}, true)
  //   if (status === 200) {
  //     const filterTypes = []
  //     data.forEach((v) => {
  //       filterTypes.push({ label: `${v.Name}`, id: v.id })
  //     })
  //     setCarTypes([...filterTypes])

  //     setCarLogoType(data)
  //   }
  // }
  const fetchCarLogoModel = async () => {
    const url = urls.fetchCarLogoModel
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterTypes = []
      data.forEach((v) => {
        filterTypes.push({ label: `${v.Name}`, id: v.id })
      })
      // setCarLogoTypes([...filterTypes])
    }
  }
  return (
    <>
      {/* <CustomButton onClick={handleClickOpen}>créer</CustomButton> */}
      <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose}>
        <DialogTitle sx={{ color: 'black !important' }}>Modifier véhicules</DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <ComboBox
              handleAutoComplete={(e, j) => {
                setVehicleType(j)
                setValue('vehicleType', j)
                setValue('Marque', '')
                setMarqueType('')
                if (j) {
                  setSelectedVehicle(j.label)
                  setVehicleMarque(j.id)
                } else {
                  setSelectedVehicle('')
                  setVehicleMarque(-1)
                }
              }}
              label="Type de véhicule"
              data={vehiculesTypes}
              name="vehicleType"
              required={true}
              selectedValue={vehicleType}
            />
            <ComboBox
              handleAutoComplete={(e, j) => {
                setValue('Marque', j)
                setMarqueType(j)
              }}
              label="Marque"
              data={carMarque}
              name="Marque"
              required={true}
              onClick={() => setVehicleMarque(vehicleType.id)}
              selectedValue={marqueType}
            />
            <ComboBox
              handleAutoComplete={(e, j) => setValue('Model', j)}
              label="Modèle"
              data={carTypes}
              name="Model"
              required={true}
              selectedValue={carType}
            />
            {/* <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'text',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name='Marque'
              label='Marque'
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type:'text',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name='Model'
              label='Modèle'
            /> */}

            <ComboBox
              handleAutoComplete={(e, j) => setValue('Motortype', j)}
              label="Type de moteur"
              data={moterType}
              name="Motortype"
              required={true}
              selectedValue={Motortypes}
            />
            {/* <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type:'number',
                required: false,
                size: 'small',
              }}
              rules={{ required: false }}
              name='Conso'
              label='Consommation L/100km'
            /> */}
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'text',
                required: false,
                size: 'small',
              }}
              rules={{ required: false }}
              name="Contact"
              label="Conducteur"
            />

            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'date',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name="DatePurch"
              label="Date d’acquisition"
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'text',
                required: false,
                size: 'small',
              }}
              rules={{ required: false }}
              name="Identification"
              label="Immatriculation"
            />
            {selectedVehicle === 'Nautisme' ? (
              <ComboBox
                handleAutoComplete={(e, j) => {
                  setValue('boatType', j)
                  setBoatTypes(j)
                }}
                label="Type de bateau"
                data={boatType}
                name="boatType"
                selectedValue={boatTypes}
              />
            ) : (
              ''
            )}

            {/* <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type:'number',
                required: false,
                size: 'small',
              }}
              rules={{ required: false }}
              name='Vhpower'
              label='Puissance fiscal (cv)'
            />
             <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type:'number',
                required: false,
                size: 'small',
              }}
              rules={{ required: false }}
              name='emission'
              label='Emission (g/co2)'
            /> */}
          </DialogContent>
          <DialogActions>
            <Button type="submit">Valider</Button>
            <Button onClick={handleClose}>Annuler</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
